import { get } from 'lodash';
import { CAMPAIGN_INSTRUCTION_TYPE } from 'modules/campaigns/config';

export const hasCampaignCarousel = campaign =>
    `${get(campaign, 'campaignItemType')}`.includes(CAMPAIGN_INSTRUCTION_TYPE.HAS_HIERARCHY_ITEMS);
